import React, { useState, useEffect } from 'react';
import DynamicBanner from '../../include/DynamicBanner';
import api from '../../../../api';
import './PgApartment.css';

const PgApartment = () => {
  const [showMore, setShowMore] = useState(false);
  const [pgData, setPgData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const getEmbedUrl = (idOrUrl) => {
    if (!idOrUrl || idOrUrl.length < 5) return null;
    if (idOrUrl.includes("youtube.com/embed/")) return idOrUrl;
    if (idOrUrl.includes("youtube.com/watch?v=")) {
      const videoId = idOrUrl.split("v=")[1]?.split("&")[0];
      return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
    }
    return `https://www.youtube.com/embed/${idOrUrl.trim()}`;
  };

  useEffect(() => {
    const fetchPgData = async () => {
      try {
        const response = await api.get("/api/sitepages/academic/life-and-care");
        const data = response.data.data["pg-apartments"];

        // Format desktop banners
        const bannerImagesDesktop =
          data.banners?.desktop?.map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean) || [];

        // Format mobile banners
        const bannerImagesMobile =
          data.banners?.mobile?.map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean) || [];

        setPgData({
          ...data,
          bannerImagesDesktop,
          bannerImagesMobile
        });

        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching PG Apartments data:", err);
        setError("Failed to load PG Apartments data");
        setIsLoading(false);
      }
    };

    fetchPgData();
  }, []);

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center m-5">
        <h4>{error}</h4>
        <button 
          className="btn btn-primary mt-3"
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
      </div>
    );
  }

  if (!pgData) {
    return (
      <div className="text-center py-5">
        <h4>No PG Apartments data available.</h4>
      </div>
    );
  }

  const {
    title,
    bannerImagesDesktop,
    bannerImagesMobile,
    content
  } = pgData;

  const {
    sec2_heading = 'PG Apartments',
    sec2_description,
    sec2_youtube
  } = content || {};

  const youtubeEmbedUrl = getEmbedUrl(sec2_youtube);

 
  const hasDescription = sec2_description && sec2_description.trim() !== '';
  const fullDescription = sec2_description || '';
  const shortDescription = fullDescription.length > 700 
    ? fullDescription.substring(0, 700) + '...'
    : fullDescription;
  const needsReadMore = fullDescription.length > 700;

  return (
    <>
      {/* ---------------- BANNER ---------------- */}
      {(bannerImagesDesktop.length > 0 || bannerImagesMobile.length > 0) && (
        <DynamicBanner
          title={title}
          bgImage={bannerImagesDesktop}
          bgImageMobile={bannerImagesMobile}
        />
      )}

      <section className="pg-section">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{sec2_heading}</h2>
          </div>

          <div className="row d-flex justify-content-center align-items-center">
            {/* Left Column - Content */}
            <div className="col-lg-6 pg-content order-2 order-lg-1">
              {hasDescription ? (
                <>
                  <div dangerouslySetInnerHTML={{ 
                    __html: showMore ? fullDescription : shortDescription 
                  }} />
                  
                  {needsReadMore && (
                    <button
                      className="readmoreall mb-3 mb-md-5 mt-3"
                      onClick={() => setShowMore((prev) => !prev)}
                    >
                      {showMore ? 'Read less' : 'Read more'}
                    </button>
                  )}
                </>
              ) : (
                <div className="text-center py-4">
                  <p>No content available for PG Apartments.</p>
                </div>
              )}
            </div>

            {/* Right Column - Video */}
            <div className="col-lg-6 order-1 order-lg-2">
              {youtubeEmbedUrl ? (
                <div
                  className="video-container-pg mb-3 mb-md-5"
                  style={{ 
                    position: 'relative', 
                    paddingBottom: '56.25%', 
                    height: 0, 
                    overflow: 'hidden',
                    backgroundColor: '#000',
                    borderRadius: '10px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                  }}
                >
                  <iframe
                    src={youtubeEmbedUrl}
                    title={sec2_heading}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ 
                      position: 'absolute', 
                      top: 0, 
                      left: 0, 
                      width: '100%', 
                      height: '100%',
                      border: '0',
                      borderRadius: '10px'
                    }}
                  ></iframe>
                </div>
              ) : (
                <div className="text-center py-4 mb-5">
                  <p>No video available for PG Apartments.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PgApartment;